export const ASSET_TYPES = [
  {
    value: 'foto',
    label: 'Foto',
    icon: 'i-lucide-image',
    color: 'bg-pink-500',
  },
  {
    value: 'video',
    label: 'Vídeo',
    icon: 'i-lucide-video',
    color: 'bg-purple-500',
  },
  {
    value: 'card',
    label: 'Card',
    icon: 'i-lucide-layout-panel-left',
    color: 'bg-blue-500',
  },
  {
    value: 'texto',
    label: 'Texto',
    icon: 'i-lucide-file-text',
    color: 'bg-slate-500',
  },
  {
    value: 'audio',
    label: 'Áudio',
    icon: 'i-lucide-mic',
    color: 'bg-amber-500',
  },
  {
    value: 'documento',
    label: 'Documento',
    icon: 'i-lucide-file',
    color: 'bg-teal-500',
  },
  {
    value: 'briefing',
    label: 'Briefing',
    icon: 'i-lucide-clipboard-list',
    color: 'bg-indigo-500',
  },
];

export const KANBAN_STATUSES = [
  {
    value: 'briefing',
    label: 'Briefing',
    color: 'bg-slate-100 text-slate-700',
    border: 'border-slate-400',
  },
  {
    value: 'producao',
    label: 'Produção',
    color: 'bg-amber-100 text-amber-700',
    border: 'border-amber-400',
  },
  {
    value: 'revisao',
    label: 'Revisão',
    color: 'bg-blue-100 text-blue-700',
    border: 'border-blue-400',
  },
  {
    value: 'aprovado',
    label: 'Aprovado',
    color: 'bg-emerald-100 text-emerald-700',
    border: 'border-emerald-400',
  },
  {
    value: 'publicado',
    label: 'Publicado',
    color: 'bg-teal-100 text-teal-700',
    border: 'border-teal-400',
  },
  {
    value: 'descartado',
    label: 'Descartado',
    color: 'bg-rose-100 text-rose-700',
    border: 'border-rose-400',
  },
];

export const PLATFORMS = [
  {
    value: 'instagram',
    label: 'Instagram',
    icon: 'i-lucide-instagram',
    color: 'bg-pink-100 text-pink-700',
  },
  {
    value: 'facebook',
    label: 'Facebook',
    icon: 'i-lucide-facebook',
    color: 'bg-blue-100 text-blue-700',
  },
  {
    value: 'tiktok',
    label: 'TikTok',
    icon: 'i-lucide-music',
    color: 'bg-slate-100 text-slate-700',
  },
  {
    value: 'twitter',
    label: 'Twitter/X',
    icon: 'i-lucide-twitter',
    color: 'bg-sky-100 text-sky-700',
  },
  {
    value: 'whatsapp',
    label: 'WhatsApp',
    icon: 'i-lucide-message-circle',
    color: 'bg-emerald-100 text-emerald-700',
  },
  {
    value: 'youtube',
    label: 'YouTube',
    icon: 'i-lucide-youtube',
    color: 'bg-rose-100 text-rose-700',
  },
];

export const assetTypeMeta = v => ASSET_TYPES.find(t => t.value === v) || {};
export const kanbanStatusMeta = v =>
  KANBAN_STATUSES.find(s => s.value === v) || {};
export const platformMeta = v => PLATFORMS.find(p => p.value === v) || {};
